import React, {FunctionComponent} from 'react';
import IconEmptyCalendar from '../../icon/IconEmptyCalendar';
import IconStudent from '../../icon/IconStudent';
import Tooltip from '../../../ui/Tooltip';
import CalendarRow from './CalendarRow';
import {FutureEvent} from './CalendarCard';
import IconTicket from '../../icon/IconTicket';

type CalendarProps = {
  events: FutureEvent[]
}

const Calendar: FunctionComponent<CalendarProps> = ({events}) =>
  (
    <div className="grid grid-cols-12 gap-x-1 gap-y-4 text-base pt-3">
      <div className="col-span-7 grid grid-cols-12 text-gray-dark">
        <div/>
        <div className="col-span-11">Title</div>
      </div>
      <div className="col-span-5">
        <div className="grid grid-cols-7">
          <div className="col-span-4"><IconEmptyCalendar className="text-gray-dark"/></div>
          <div className="text-right">
            <Tooltip content="Number of students" label="students"><IconStudent className="text-green"/></Tooltip>
          </div>
          <div className="text-right">
            <Tooltip content="Number of sold tickets" label="tickets"><IconTicket
              className="text-gray-dark"/></Tooltip>
          </div>
        </div>
      </div>
      {events.map((event) => <CalendarRow key={event.id} title={event.title} id={event.id}
        schedule={event.schedule}
        location={event.location}
        students={event.statistics.students}
        soldTickets={event.statistics.soldTickets}/>)}

    </div>
  );

export default Calendar;
